import React, { useState, useEffect } from 'react';
import { testFirestoreConnection } from '../firebaseConfig';

const FirestoreTest = () => {
  const [connectionStatus, setConnectionStatus] = useState('testing');
  const [lastTest, setLastTest] = useState(null);

  const testConnection = async () => {
    setConnectionStatus('testing');
    const result = await testFirestoreConnection();
    setConnectionStatus(result ? 'connected' : 'disconnected');
    setLastTest(new Date().toLocaleTimeString());
  };

  useEffect(() => {
    testConnection();
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: connectionStatus === 'connected' ? '#10B981' : 
                  connectionStatus === 'disconnected' ? '#EF4444' : '#F59E0B',
      color: 'white',
      padding: '8px 12px',
      borderRadius: '6px',
      fontSize: '12px',
      fontWeight: '600',
      zIndex: 9999,
      cursor: 'pointer',
      boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
    }}
    onClick={testConnection}
    title={`Last test: ${lastTest || 'Never'}`}
    >
      🔥 Firestore: {connectionStatus}
    </div>
  );
};

export default FirestoreTest;
